

// Class Definition
var TextUpLowCaseComponent = function() {
    var initUpLow = function() {

   

        $('#lowCase').on('click', function()
        {
            $("#textActions").val( $("#textActions").val().toLowerCase() );
        });

        $('#upCase').on('click', function()
        {
            $("#textActions").val( $("#textActions").val().toUpperCase() );
        });
        $('#randCase').on('click', function()
        {
            var text = $("#textActions").val().toLowerCase();
            text = text.split('');
            for (var i=0; i<text.length; i=i+2) {
                text[i] = text[i].toUpperCase();
            }
            text = text.join('');
            $("#textActions").val( text );
        });
        
        $('#sentenceCase').on('click', function()
        {
            var text = $("#textActions").val().toLowerCase();
            text = text.replace(/(\s*[\.\!\?\r\n|\n|\r]\s*)/g, "$1#sentence_case");
            text = text.split('#sentence_case');

            for (var i=0; i<text.length; i++) {
                var spacesLeft = text[i].match(/(^\s+)/) || '';

                // replace a string with only spaces before new line
                if(typeof spacesLeft == 'object') {
                    for (var j=0; j<spacesLeft.length; j++) {
                        spacesLeft[j] = spacesLeft[j].trim().toString().replace(/(\r\n|\n|\r)/, "");
                    }
                    spacesLeft = spacesLeft.join('');
                }
                var spacesRight = text[i].match(/(\s+)$/gm) || '';

                text[i] = text[i].trim();
                if (text[i].length > 0) {
                    if (text[i].charAt(0) == '“' || text[i].charAt(0) == '"' || text[i].charAt(0) == "'") {
                        text[i] = text[i][0] + text[i][1].toUpperCase() + text[i].slice(2);
                    } else {
                        text[i] = text[i][0].toUpperCase()+text[i].slice(1);
                    }
                }
                text[i] = spacesLeft+text[i]+spacesRight
            }
            text = text.join('');
            $("#textActions").val(text);
        });


        $('#capitalizeWord').on('click', function()
        {

            var palavras_ignoradas = [""],tamanho_minimo = 1;
            var str = '';
            palavras_ignoradas = str.split(",");


            var palavras = $("#textActions").val().toLowerCase().match(/\S+\s*/g);
            $.each(palavras, function (i, palavra) {

                if ($.trim(palavras_ignoradas).indexOf($.trim(palavra)) == -1 && $.trim(palavra).length > tamanho_minimo)
                {
                    if (palavras[i].charAt(0) == '“' || palavras[i].charAt(0) == '"' || palavras[i].charAt(0) == "'") {
                        palavras[i] = palavras[i].charAt(0) + palavras[i].charAt(1).toUpperCase() + palavras[i].slice(2);

                    } else {
                        palavras[i] = palavras[i].charAt(0).toUpperCase() + palavras[i].slice(1);
                    }
                }
            });

            $("#textActions").val( palavras.join("") );
        });
         

    }

    return {
        init: function() {
            initUpLow();
        }
    };
}();

// Class Initialization
$(function(){
    TextUpLowCaseComponent.init();
    
    
});





  

    
